module.exports = __webpack_public_path__ + "media/1.121a2fcf.wav";